export const debounce = <Args extends unknown[]>(
  func: (...args: Args) => void,
  wait: number,
) => {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  return (...args: Args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

export const debounceLeading = <Args extends unknown[]>(
  func: (...args: Args) => void,
  wait: number,
) => {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  return (...args: Args) => {
    const isIdle = timeout === undefined;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = undefined;
    }, wait);
    if (isIdle) func(...args);
  };
};
